import React from "react";
import Cookies from "universal-cookie";
import "../../../App.css";
// import "Components/SideMenu.css";
import BarChart from "../MohDashboardComponents/BarChart";
import CandleStickChart from "../MohDashboardComponents/CandleStickChart";
import DoughnutChart from "../MohDashboardComponents/DoughnutChart";
import DoughnutChart2 from "../MohDashboardComponents/DoughnutChart2";
import SeriesChart from "../MohDashboardComponents/SeriresChart";

const cookies = new Cookies();
const MofReportDashboard = (props) => {
  const goBack = () => {
    if (
      cookies.get("token") &&
      cookies.get("user-type") &&
      cookies.get("user-type") === "3"
    )
      window.location.href = "/moh-dashboard";
    else window.location.href = "/";
  };

  // if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '3') {
  return (
    <div
      className={`mof-dashboard-div    ${
        props.inactive === false ? "activeSideMenu " : ""
      }`}
      style={{ color: "#2E5266FF" }}
    >
      <div className="mof-dashboard-heading">
        <div style={{ fontSize: 56 }}>
          مرحباً بك في{" "}
          {cookies.get("role_id") == 0
            ? "لوحة التحكم   "
            : "الصفحة الرئيسية   "}
          {cookies.get("userName") == "branch manager"
            ? "س.مدير الفرع"
            : cookies.get("userName") == "checker"
            ? "س.مدقق"
            : cookies.get("userName") == "estimator"
            ? "س.مخمن"
            : cookies.get("userName") == "tax payer"
            ? "س.المكلف"
            : cookies.get("userName") == "officer"
            ? "س.الكاتب"
            : "س.المسؤل"}
        </div>
      </div>

      <div className="charts">
        <div className="chart-card">
          <h2>المثال الاول</h2>
          <BarChart />
        </div>
        <div className="chart-card">
          <h2>المثال الثاني</h2>
          <DoughnutChart />
        </div>
        <div className="chart-card">
          <h2>المثال الثالث</h2>
          <DoughnutChart2 />
        </div>
      </div>
      <div className="charts">
        <div className="chart-card">
          <h2>المثال الرابع</h2>
          <CandleStickChart />
        </div>
        <div className="chart-card" style={{ flex: 3 }}>
          <h2>المثال الخامس</h2>
          <SeriesChart />
        </div>
      </div>

      <div onClick={() => goBack()} className="mof-dashboard-footer">
        <div style={{ fontSize: 16, textAlign: "end" }}>الرجوع</div>
      </div>
    </div>
  );
  // } else {
  //     window.location.href = "/"
  // }
};

export default MofReportDashboard;
